//= include ../../../node_modules/jquery/dist/jquery.js
//= include ../../../node_modules/popper.js/dist/umd/popper.js

//= include ../../../node_modules/bootstrap/js/dist/util.js
//= include ../../../node_modules/bootstrap/js/dist/alert.js
//= include ../../../node_modules/bootstrap/js/dist/button.js
//= include ../../../node_modules/bootstrap/js/dist/carousel.js
//= include ../../../node_modules/bootstrap/js/dist/collapse.js
//= include ../../../node_modules/bootstrap/js/dist/dropdown.js
//= include ../../../node_modules/bootstrap/js/dist/modal.js
//= include ../../../node_modules/bootstrap/js/dist/tooltip.js
//= include ../../../node_modules/bootstrap/js/dist/popover.js
//= include ../../../node_modules/bootstrap/js/dist/scrollspy.js
//= include ../../../node_modules/bootstrap/js/dist/tab.js
//= include ../../../node_modules/bootstrap/js/dist/toast.js

//= include ../../../node_modules/air-datepicker/dist/js/datepicker.js
//= include ../../../node_modules/owl.carousel/dist/owl.carousel.js
//= include ../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.js
//= include custom.js
//= include testing.js
